<template>
    <div class="mx-auto px-4 py-4 sm:px-6 lg:px-6 min-h-80vh">
        <h1 class="text-lg leading-6 font-medium">
            Membership Report
        </h1>
        <div class="
          bg-white
          shadow
          overflow-hidden
          sm:rounded-lg
          shadow
          overflow-auto
          border-b border-gray-200
          sm:rounded-lg
        ">
            <form class="mt-5 sm:flex sm:items-center px-8">
                <div class="w-full sm:max-w-md mr-2">
                    <label for="status_select" class="sr-only">Membership Status</label>
                    <select id="status_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Membership Status" v-model="search.status">
                        <option value="">All Statuses</option>
                        <option value="Active">Active Membership Report</option>
                        <option value="Inactive">Inactive Membership Report</option>
                        <option value="Terminated">Terminated Membership Report</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <label for="company_select" class="sr-only">Select Company</label>
                    <select id="company_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Company" v-model="search.company">
                    <option value="">Select Company</option>
                    <option :value="com.id" v-for="com in company_list"
            :key="com.id">
            {{ com.name }}, {{com.number}}
        </option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <label for="payment_type_select" class="sr-only">Select Payment Type</label>
                    <select id="payment_type_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Payment Type" v-model="search.payment_type">
                    <option value="">All Payment Types</option>
                    <option value="I-Invoice">I-Invoice</option>
                    <option value="P-Payroll">P-Payroll</option>
                    <option value="V-Credit Card">V-Credit Card</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <label for="pay_range_select" class="sr-only">Select Payment Date Range</label>
                    <select id="pay_range_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Payment Date Range" v-model="search.last_pay_day">
                        <option value="">All Payments</option>
                        <option value="No Pmts">No Payments</option>
                        <option value="30">Payments Last 30 Days</option>
                        <option value="60">Payments Last 30-60 Days</option>
                        <option value="90">Payments Last 60 plus Days</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <label for="member_search" class="sr-only">Search by member name</label>
                    <input 
                        type="text"
                        id="member_search"
                        class="
                            h-10
                            form-input
                            appearance-none
                            block
                            w-full
                            px-3
                            py-1.5
                            text-base
                            font-normal
                            text-gray-700
                            bg-white bg-clip-padding bg-no-repeat
                            border border-solid border-gray-300
                            rounded
                            transition
                            ease-in-out
                            m-0
                            focus:text-gray-700
                            focus:bg-white
                            focus-border-navy
                        "
                        placeholder="Search by member name"
                        aria-label="Search by member name"
                        v-model="search.member"
                    />
                </div>
                <div class="w-full sm:max-w-md mr-2 items-center justify-between">
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " type="button" @click="getReportData()">
                        Search
                    </button>
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " v-if="data?.length > 0" type="button" @click="exportCSV($event)">
                        Export
                    </button>
                    <button class="
                  mt-2
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-white
                  bg-gray-600
                  hover:bg-gray-800
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-gray-500
                " type="button" @click="clearFilter()">
                        Clear
                    </button>
                </div>
            </form>
            <div
              ref="resultsRegion"
              tabindex="0"
              role="region"
              aria-label="Membership report results"
              aria-describedby="membership_report_columns"
            >
              <span id="membership_report_columns" class="sr-only">
                Membership report results table. Columns: Company number, Company name, Member ID, Last name, First name, Member status, Plans, Payment type, Effective date, Last payment date, Inactive date, Termination date.
              </span>
              <DataTable  id="membership_report" @page="onPageChange($event)"
              @sort="onSort($event)"
              ref="dt"
              :totalRecords="totalRecords"
              :first="first"
              :lazy="lazyParams" :paginator="true"
              :resizableColumns="true" columnResizeMode="expand"
                class="mt-5 min-w-full divide-y divide-gray-200"
                :value="data"
                :alwaysShowPaginator="false"
                :rowsPerPageOptions=[5,10,20,50,70,100]
                :rows="10"
              >
                <template #empty>
                  No Records Found
                </template>
                <Column
                  v-for="column in columns"
                  :key="column.title"
                  :field="column.key"
                  :style="{ 'width': '50px' }"
                  exportFilename="exportfilename"
                  :sortable="(column.key=='name' || column.key=='last_name' || column.key=='first_name') && totalRecords>0"
                >
                  <template #header>
                      <template v-if="!((column.key=='name' || column.key=='last_name' || column.key=='first_name') && totalRecords>0)">
                        {{ column.title }}
                      </template>
                      <span v-else>
                        {{ column.title }}<span class="sr-only"> sortable</span>
                      </span>
                  </template>
                  <template #body="slotProps">
                      <template v-if="column.key == 'mem_num'">
                          <span
                            class="tooltip text-blue-700 cursor-pointer"
                            tabindex="0"
                            role="button"
                            :aria-label="`Member ID. View member details. ${slotProps?.data?.mem_num || ''}`"
                            @click="openMemberDetails(slotProps?.data,true)"
                            @keydown.enter.prevent="openMemberDetails(slotProps?.data,true)"
                            @keydown.space.prevent="openMemberDetails(slotProps?.data,true)"
                          ><span class="tooltip-text">View Member details</span><i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ slotProps?.data?.mem_num }}</span>
                      </template>
                      <template v-else>
                          <span>
                            <span class="sr-only">{{ getCellAriaLabel(column, slotProps?.data) }}</span>
                            <span aria-hidden="true">{{ slotProps.data[column.key] }}</span>
                          </span>
                      </template>
                  </template>
                </Column>
              </DataTable>
            </div>
        </div>
        <div id="practice_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal_title"
        class="z-40 left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-2/5 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-2 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p id="modal_title" class="font-semibold text-gray-800 p-1"><i class="fa fa-user-circle-o" aria-hidden="true"></i> Member Information
               </p>
            </div>
            <div class="flex flex-col">
                <div class="grid grid-cols-2 gap-4">
                <div class="p-4 border">
                    <p class="font-bold">Member Name</p>
                    <p>{{member_details?.first_name}} {{member_details?.last_name}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Phone</p>
                    <p>{{member_details?.phone}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Email</p>
                    <p class="break-all">{{member_details?.email}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Address</p>
                    <p>{{member_details?.address1}}, {{member_details?.city}}, {{member_details?.state}} - {{member_details?.zip}}</p>
                </div>
                </div>
                <button
                type="button"
                @click="openMemberDetails(false)"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white bg-red-600 hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-50"
              >
                <i
                  class="fa fa-circle-o-notch mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Close</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery"; // To use jquery
import Constants from "../constants.ts";
// import axios from "axios";
import { ref } from 'vue';
export default {
    data() {
        return {
            member_details:{},
            focusedInput: null,
            API_BASE: Constants.API_BASE,
            columns: [
                {
                    title: "Company #",
                    key: "com_num",
                },
                {
                    title: "Company Name",
                    key: "name",
                },
                {
                    title: "Member ID#",
                    key: "mem_num",
                },
                {
                    title: "Last Name",
                    key: "last_name",
                },
                {
                    title: "First Name",
                    key: "first_name",
                },
                {
                    title: "Member Status",
                    key: "member_status",
                },
                {
                    title: "Plan(s)",
                    key: "planType",
                },
                {
                    title: "Payment Type",
                    key: "payment_method",
                },
                {
                    title: "Effective Date",
                    key: "effective_date",
                },
                {
                    title: "Last Payment Date",
                    key: "last_payment_date",
                },
                {
                    title: "Inactive Date",
                    key: "inactive_date",
                },
                {
                    title: "Termination Date",
                    key: "terminated_date",
                }
            ],
            search: {
                flt_str: ""
            },
            first : ref(0),
            totalRecords :ref(0),
            lazyParams : ref({}),
            company_list:[],
            data: ref(0),
            totalAmount: 0,
            totalComm: 0,
            config: {
                wrap: true,
                altFormat: "m-d-Y",
                altInput: true,
                dateFormat: "m-d-Y",
            },
        };
    },
    computed: mapState(["agent_user","token"]), // get central level variable from store
    mounted() {
        this.search.status = 'Active';
        this.search.company = '';
        this.search.payment_type = '';
        this.search.last_pay_day = '';
        this.search.member = '';
        this.getCompany();
        // this.getReportData();
        this.lazyParams.value = {
        first: 0,
        rows: 10,
    };
        this.fixDataTableAria();
    },
    updated() {
        this.fixDataTableAria();
    },
    methods: {
        fixDataTableAria() {
            this.$nextTick(() => {
                const root = this.$refs.dt?.$el;
                if (!root) return;
                root.querySelectorAll('th[role="cell"]').forEach((th) => {
                    th.setAttribute('role', 'columnheader');
                });
                const paginatorLabels = {
                    '.p-paginator-first': 'First Page',
                    '.p-paginator-prev': 'Previous Page',
                    '.p-paginator-next': 'Next Page',
                    '.p-paginator-last': 'Last Page',
                };
                Object.entries(paginatorLabels).forEach(([selector, label]) => {
                    root.querySelectorAll(selector).forEach((btn) => {
                        btn.setAttribute('aria-label', label);
                        btn.querySelector('.p-paginator-icon')?.setAttribute('aria-hidden', 'true');
                    });
                });
                root.querySelectorAll('.p-paginator .p-hidden-accessible input[readonly]').forEach((input) => {
                    input.removeAttribute('aria-expanded');
                    if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
                        input.setAttribute('aria-label', 'Rows per page');
                    }
                });
                root.querySelectorAll('.p-paginator .p-dropdown-trigger').forEach((trigger) => {
                    trigger.setAttribute('aria-label', 'Rows per page');
                    trigger.querySelector('.p-dropdown-trigger-icon')?.setAttribute('aria-hidden', 'true');
                });
            });
        },
        getCellAriaLabel(column, rowData) {
            const raw = rowData ? rowData[column.key] : "";
            const value = raw === null || raw === undefined || raw === "" ? "blank" : String(raw);
            return `${column.title}: ${value}`;
        },
        onSort(event){  
            console.log(event)
            this.lazyParams.value = event;
            this.getReportData(event);
        },
        onPageChange(event) {
        this.lazyParams.value = event;
        this.getReportData(event);
        $('html, body').animate({ scrollTop: 0 });
    },
        openMemberDetails(details='',flag){
            if (flag) {
                this._lastFocusedEl = document.activeElement;
                this.member_details=details;
                document.getElementById("practice_detail").classList.remove("hidden");
                this.$nextTick(() => {
                    const dialog = document.querySelector('#practice_detail [role="dialog"]');
                    dialog?.focus?.();
                });
            } else {
                document.getElementById("practice_detail").classList.add("hidden");
                this.$store.dispatch("getAttProfileData");
                this.$nextTick(() => {
                    this._lastFocusedEl?.focus?.();
                    this._lastFocusedEl = null;
                });
            }
        },
        onFocus(refKey) {
            this.focusedInput = refKey;
        },
    getCompany(){
        this.$http
                .get(
                    `fetch_agent_company.php`,
                    {
                        headers: {
                            Authorization: this.token,
                            AgentSelected:this.agent_user.id
                        },
                    }
                )
                .then((response) => {
                    if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                        console.log(response);
                        this.company_list = response.data;
                    }
                })
                .catch((e) => {
                    this.$store.state.loader = false;
                    console.log("e", e);
                });
    },
        exportCSV() {
            // this.$refs.dt.exportCSV();
            let filter_str = "?";
            filter_str += "&last_pay_day=" + this.search.last_pay_day;
            filter_str += "&member=" + this.search.member;
            filter_str += "&status=" + this.search.status;
            filter_str += "&company=" + this.search.company;
            filter_str += "&payment_type=" + this.search.payment_type;
            filter_str += "&report_name=membership_report";
            filter_str += "&act=" + encodeURIComponent(this.token);
            filter_str+="&agents="+this.agent_user.id;
            console.log(filter_str)
            window.location.href = this.API_BASE + "export_to_csv.php" + filter_str;
        },
        clearFilter() {
            this.search.flt_str="";
            this.search.status = '';
            this.search.company = '';
            this.search.payment_type = '';
            this.search.last_pay_day = '';
            this.search.member = '';
            this.data=[];
            this.totalRecords=0
            // this.getReportData();
        },
        getReportData(event) {
            document.getElementById("loader").classList.remove("hidden");

            this.lazyParams.value = { ...this.lazyParams.value, first: event?.first || this.first };
                    let filter={'limit':10,'offset':0,'sortField':'name asc'};
                    if(event?.rows>0){
                        let order='asc';
                        if(event.sortOrder==-1){
                            order='desc';
                        }
                        if(event.sortField=='' || event.sortField==null){
                            event.sortField='name'; 
                        }
                        filter={'limit':event.rows,'offset':event.first,'sortField':event.sortField+' '+order};
                    }
                    
                    this.$http
                        .post(
                            `membership_report.php`,
                            {'search':this.search,"paginate":filter},
                            {
                                headers: {
                                    Authorization: this.token,
                                    AgentSelected:this.agent_user.id
                                },
                            }
                        )
                        .then((response) => {
                            document.getElementById("loader").classList.add("hidden");
                            this.$store.state.loader = false;
                            if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                                console.log(response);
                                this.data = response.data.data;
                                this.totalRecords = response.data.totalRecords;
                                this.$nextTick(() => {
                                  this.$refs?.resultsRegion?.focus?.();
                                });
                            }
                        })
                        .catch((e) => {
                            document.getElementById("loader").classList.add("hidden");
                            this.$store.state.loader = false;
                            console.log("e", e);
                        });
        },
    },
};
</script>
<!-- <style scoped>
table th, table td{
  white-space: normal !important;
  font-size: 14px !important;
}
</style> -->